module.exports = __webpack_public_path__ + "static/media/how-we-speak.49eaab6f.svg";